import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../sass/Popup.scss";
import { isMobile } from "react-device-detect";
import { SelectedDataSet } from "./context/SelectedDataset";
import { toast, ToastContainer } from "react-toastify";
const Popup = ({ children, setPickLoc }) => {
  // console.log(children);
  const { selectedDataSet } = useContext(SelectedDataSet);
  const { getSelectedDataSet } = useContext(SelectedDataSet);
  let bigpop = false;
  let a = useLocation();
  if (a.pathname.includes("/customise-data") == true) {
    bigpop=true
  }
  // console.log(selectedDataSet)
  // console.log(open)
  const notify = () => toast.error('You can not add more than 10 datasets at once', {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme:"dark",
  });
  // const newFn = () => {
  //   console.log("running...");
  // }
    // if (open == true) {
    //   notify();
    //   // newFn();
    // }
    // notifyFn(false)
  let navigate = useNavigate();

  function onDismiss() {
    // navigate(-1);
    // setPickLoc(false);
  }
  useEffect(() => {
    getSelectedDataSet();
  }, [])
  // console.log("sdfgyhuji")
  return (
    <div className={`${!isMobile ? "popupWrapper" : "popupWrapperMob"}`}>
      
        <ToastContainer />
      <div className={`${!isMobile && bigpop==false?"popupContainer":!isMobile && bigpop==true?"popupContainerbig":isMobile && bigpop==false?"popupContainerMob":isMobile && bigpop==true&&"popupContainerMobBig"}`}>{children}</div>
      <span className="popupBg" onClick={onDismiss}></span>
    </div>
  );
};
export default Popup;
